module.exports = __webpack_public_path__ + "campaigns.svg?8f02aeda8e698ae16c93ca8513d1f45b";